export default "__VITE_ASSET__8c6dfdc7__"